import first from 'lodash/first'
import isEqual from 'lodash/isEqual'

import { CartV2LineItem } from '@Domains/Cart/Feature/CartV2/CartV2'

const getVariantSizeLabel = size => size?.value?.label || undefined
const getVariantSizeLocaleLabel = (size, locale) => getVariantSizeLabel(size)?.[locale]

const getLineItemVariantSize = (lineItem: CartV2LineItem) => (lineItem.variant?.size?.__typename === 'BaseAttribute' ? lineItem.variant?.size : undefined)
export const getLineItemProperties = (lineItem: CartV2LineItem, locale, props: { parent?: CartV2LineItem }) => {
  const normalPriceIsZero = isEqual(lineItem?.totalPrice?.plain, '0')
  const isFree = isEqual(lineItem.totalPrice?.discount ? lineItem.totalPrice?.discount?.plain : lineItem.totalPrice?.plain, '0')
  const isDiscounted = !!lineItem.totalPrice?.discount
  const giftWrapping = lineItem.variant?.giftWrappings?.__typename === 'ProductAttribute' && first(lineItem.variant?.giftWrappings?.products)
  const isSizeable = (lineItem.product?.variants || []).filter(v => v.size).length > 1
  const isQuantifiable = !props.parent
  const hasSize = props.parent ? false : !!lineItem?.variant?.size
  const productName = lineItem.product ? `${lineItem.product.brand?.title ? `${lineItem.product.brand?.title} - ` : ''}${lineItem.product.name}` : ''
  const lineItemSize = !lineItem ? undefined : (lineItem.variant?.size)
  // @ts-ignore
  const getSizeLabel = (item: CartV2LineItem) => getLineItemVariantSize(item)?.value?.label[locale] || getLineItemVariantSize(item)?.value?.key
  const isFreeGiftItem = props.parent?.type?.__typename === 'CartLineItemTypeFreeProduct' || lineItem.type?.milestoneID || lineItem.tactic
  const freeGiftItemIsSizable = props.parent?.type?.__typename === 'CartLineItemTypeFreeProduct'
      && (props.parent.product?.variants || []).filter(v => v.size).length > 1
  const freeGiftItemDisableSizeSelection = props.parent?.type?.__typename === 'CartLineItemTypeFreeProduct' && !!props.parent.type.disableSizeSelection
  const freeGiftItemHasSelectedVariant = props.parent?.type?.__typename === 'CartLineItemTypeFreeProduct' && !!props.parent.type.hasSelectedVariant
  const sizeSelected = (lineItem.product?.variants || []).find(
    variant => getVariantSizeLocaleLabel(variant.size, locale) === getVariantSizeLocaleLabel(lineItemSize, locale),
  )

  return {
    giftWrapping,
    hasSize,
    isDiscounted,
    isFree,
    isQuantifiable,
    isSizeable,
    normalPriceIsZero,
    freeGiftItemIsSizable,
    isFreeGiftItem,
    getSizeLabel,
    productName,
    freeGiftItemDisableSizeSelection,
    freeGiftItemHasSelectedVariant: freeGiftItemDisableSizeSelection
      ? true
      : freeGiftItemHasSelectedVariant,
    quantityAvailable: sizeSelected?.availability?.quantity || lineItem.product?.availability?.quantity || 0,
    totalPriceDiscountValue: lineItem.totalPrice?.discount?.value,
    totalPriceDiscountFormat: lineItem.totalPrice?.discount?.format,
    totalPriceValue: lineItem.totalPrice?.value,
    totalPriceFormat: lineItem.totalPrice?.format,
    priceSaveFormat: lineItem.totalPrice?.discount?.value === 0
      ? lineItem.totalPrice?.format
      : (lineItem.totalPrice?.discount?.format || lineItem.totalPrice?.format),
    sizeOptions: (lineItem.product?.variants || []),
    sizeSelected,
  }
}
